import { render } from "./Index.vue?vue&type=template&id=4c9c957e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4c9c957e&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9c957e"]])

export default __exports__